<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Crear producto</p>
              </div>
            </div>
            <div class="card-body">
              <form @submit.prevent="submitProduct">
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Código</label>
                    <argon-input v-model="product.code" type="text" />
                    <small v-if="submitted && v$.product.code.$error" class="text-danger">Código requerido</small>
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Nombre</label>
                    <argon-input v-model="product.name" type="text" />
                    <small v-if="submitted && v$.product.name.$error" class="text-danger">Nombre requerido</small>
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label">Tasa mínima (%)</label>
                    <argon-input v-model="product.min_rate" type="number" step="0.01" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label">Tasa máxima (%)</label>
                    <argon-input v-model="product.max_rate" type="number" step="0.01" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label">Tasa por defecto (%)</label>
                    <argon-input v-model="product.default_rate" type="number" step="0.01" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Monto mínimo</label>
                    <argon-input v-model="product.min_amount" type="number" step="0.01" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Monto máximo</label>
                    <argon-input v-model="product.max_amount" type="number" step="0.01" />
                  </div>
                </div>
                <argon-button
                  type="submit"
                  class="mt-4"
                  color="success"
                  fullWidth
                  size="lg"
                >Guardar</argon-button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import axios from "axios";

export default {
  name: "ProductForm",
  components: { ArgonInput, ArgonButton },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      submitted: false,
      product: {
        code: '',
        name: '',
        company_id:1,
        min_rate: 0.00,
        max_rate: 0.00,
        default_rate: 0.00,
        min_amount: 0.00,
        max_amount: 0.00
      }
    };
  },
  validations() {
    return {
      product: {
        code: { required },
        name: { required }
      }
    };
  },
  methods: {
    submitProduct() {
      this.submitted = true;
      this.v$.$touch();
      if (!this.v$.$invalid) {
        const token = localStorage.getItem("accessToken");
        const config = { headers: { "X-Authorization": `Bearer ${token}` } };

        axios.post(this.$store.state.apiURL + 'add/products', this.product, config)
          .then(() => {
            this.$swal({
              title: 'Producto creado',
              text: 'El producto fue registrado correctamente.',
              icon: 'success',
              confirmButtonColor: '#0b9257'
            }).then(() => {
              this.$router.push('/products');
            });
          })
          .catch((err) => {
            console.error(err);
            this.$swal({
              title: 'Error',
              text: 'No se pudo guardar el producto.',
              icon: 'error',
              confirmButtonColor: '#0b9257'
            });
          });
      } else {
        this.$swal({
          title: 'Datos inválidos',
          text: 'Por favor, revisa los campos requeridos.',
          icon: 'warning',
          confirmButtonColor: '#0b9257'
        });
      }
    }
  }
};
</script>
  